module.exports = __webpack_public_path__ + "static/arminvanbuuren_1-deba014f5a12903ff75f813d810ff4ba.jpg";